export default {
  SET_EMPLOYEECONTRACTTYPES (state, employeeContractTypes) {
    state.employeeContractTypes = employeeContractTypes
  },
}